module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAAAXNSR0IArs4c6QAAATpJREFUSEu9lr8rxlEUxj+PQUwGhcVELH7E+GZQlE38A16rjJR/QZRJshGjycokmUwy+DGY2CnK9ujoq97eyHLue9Zbz+fec885zxEJYfsUuJK09ZecEjjYfgF6gJqk6980s0DrwDZwB0xK+myGZYHagAtgCtiRtFYEFKK2B4AboBOYlnTZCEt50Y+g7RVgD3gCxiR9/Jxlg0LvDJgF9iUF+DtSQVUK+4FboAuYkxTgfFAFqwOHwDMwIukt/UUN/xVNPA8cSarLdjcQFZMdfcAJ0A4sBOgBGMqmNOk9BugeGG4FKFI3WADU25C6xVYUw7GkpSIg28vAQVXeo5Je00G2yzes7bj4OTBTdATZXgV2q6E6Luk9fdbZjsoNm+goZhO2w/jCf2pFjc/2BrAJRPNPlLTyli0n/65bX3YLfF61PwhxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 1